/**
 * Created by slava on 4/5/17.
 */

cleverapps.SocialManager = {
    login: function (callback, options) {
        if (connector.platform.oneOf(connector.MICROSOFT)) {
            cleverapps.loading.show();
        }

        cleverapps.abExperiments.allLogEvent(cleverapps.EVENTS.STATS.LOGIN_OPEN);

        connector.social.loginCallback((success) => {
            cleverapps.loading.hide();

            if (success) {
                cleverapps.abExperiments.allLogEvent(cleverapps.EVENTS.STATS.LOGIN_SUCCESS);
            }

            callback(success);
        }, options);
    },

    enforceLogin: function (callback, options) {
        options = options || {};

        if (cleverapps.flags.nologin) {
            callback(cleverapps.CODE_SUCCEED);
            return;
        }

        if (!connector.social.isConnected()) {
            cleverapps.notification.create(Messages.get("SocialManager.Initialization"));
            callback(cleverapps.CODE_FAILED);
            return;
        }

        if (connector.social.isLoggedIn({ strict: options.strict })) {
            callback(cleverapps.CODE_SUCCEED);
            return;
        }

        if (!options.withWindow && !connector.social.needWindowForLogin) {
            cleverapps.SocialManager.login((success) => {
                if (success) {
                    callback(cleverapps.CODE_SUCCEED);
                } else {
                    callback(cleverapps.CODE_FAILED);
                }
            });
            return;
        }

        const SignInWindowClass = options.signInWindow === "viral" && SignInViralWindow || options.signInWindow === "purchase" && SignInPurchaseWindow || SignInWindow;

        cleverapps.focusManager.display({
            focus: "EnforceSignInWindow",
            stack: true,
            action: (f) => {
                new SignInWindowClass({
                    onSuccess: function () {
                        callback(cleverapps.CODE_SUCCEED);
                    },
                    onFailure: function () {
                        callback(cleverapps.CODE_FAILED);
                    },
                    errorMessage: options.errorMessage
                });

                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    },

    onFailedLogin: function () {
        cleverapps.notification.create(Messages.get("SocialManager.FailedLogging"));
    },

    onLogin: function (params) {
        // console.log("onLogin", connector.player.name);

        const newId = params.newId;
        const oldId = params.oldId;

        if (connector.SYNC_STATUS.NEED_LOGIN === connector.synchronizer.status) {
            connector.synchronizer.setStatus(connector.SYNC_STATUS.INIT);
        }

        // tmp id --> social id
        if (PlatformLogic.isTmpId(oldId) || PlatformLogic.isDeviceId(oldId)) {
            cleverapps.RestClient.post(`/users/off/${oldId}`, { newId }, (response) => {
                console.log(`Success marked off: ${oldId}, newId: ${newId}, response ${JSON.stringify(response)}`);
            }, () => {
                console.log(`Failed marking off: ${oldId}, newId: ${newId}`);
            });
            levels.user.setLoggedIn(Date.now());

            connector.synchronizer.reset();

            if (connector.platform.oneOf(connector.CRAZY)) {
                levels.user.setGuest(true);
            }

            cleverapps.info.onChangeUserId();

            if (cleverapps.userClan) {
                cleverapps.userClan.changeUserId(oldId, newId);
                cleverapps.userClan.load();
            }

            cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.LOGIN, {
                method: connector.info.source
            });
        // social id --> social id
        } else if (oldId !== newId) {
            cleverapps.eventBus.trigger("userChanged");
            console.log(`second login! old - ${oldId}, new - ${newId}`);

            cleverapps.metrics.logEvent(cleverapps.EVENTS.DEBUG.SECOND_LOGIN);

            if (cleverapps.config.debugMode && connector.platform.oneOf(connector.WECHAT)) {
                alert(`second login! old - ${oldId}, new - ${newId}`);
            }

            if (!connector.info.isNative && !connector.platform.oneOf(connector.MSSTART, connector.WECHAT)) {
                connector.dataLoader.cleanAll();
                cleverapps.dataLoader.cleanAll();
                connector.dataLoader.setEnabled(false);
                cleverapps.dataLoader.setEnabled(false);
                window.location.reload();
                return;
            }

            connector.synchronizer.reset();
            cleverapps.friends.reset();
        }

        // onLogin
        cleverapps.dataLoader.processSaveQueue();

        if (connector.synchronizer.started) {
            connector.synchronizer.checkSession();
        }

        cleverapps.whenAllInitialized(() => this.onLoginRefreshes());
    },

    onLogout: function () {
        if (!connector.platform.oneOf(connector.ARKADIUM)) {
            return;
        }

        connector.dataLoader.cleanAll();
        cleverapps.dataLoader.cleanAll();
        connector.dataLoader.setEnabled(false);
        cleverapps.dataLoader.setEnabled(false);

        const localStorage = connector.dataLoader.getLocalStorage();
        if (localStorage._flush) {
            localStorage._flush();
        }

        setTimeout(() => {
            window.location.reload();
        }, 500);
    },

    onLoginRefreshes: function () {
        connector.player.whenReady(() => {
            const userName = connector.player.firstName || connector.player.name;
            if (userName && !cleverapps.flags.nologin) {
                let image;
                if (connector.player.avatar) {
                    image = new cleverapps.UI.Avatar(connector.player.avatar);
                    if (!image.width || !image.height) {
                        image = undefined;
                    }
                }
                cleverapps.notification.create(Messages.get("SocialManager.Welcome", { userName }), {
                    image
                });
            }
        });

        cleverapps.restoreProgress.update();

        connector.conversions.trackUserId();
    },

    onPlayerInfoChanged: function () {
        // console.log("onPlayerInfoChanged", connector.player.name);

        let name;
        if (connector.player.name) {
            name = connector.player.name.substring(0, 50);
        }

        let avatar;
        if (typeof connector.player.avatar === "string") {
            avatar = connector.player.avatar;
        }

        if (name) {
            cleverapps.info.setKeyValue("name", name);
        }
        if (avatar) {
            cleverapps.info.setKeyValue("avatar", avatar);
            cleverapps.UI.Avatar.preload(avatar);
        }

        if (cleverapps.miniGame) {
            cleverapps.miniGame.refreshItems();
        }
    },

    share: function (channel, shareId, callback) {
        const shareData = cleverapps.SocialManager.getShareData(shareId);
        shareData.channel = channel;

        new ActionPlayer([
            (f) => {
                if (channel === "shareNative") {
                    f();
                    return;
                }

                cleverapps.SocialManager.enforceLogin((code) => {
                    if (code === cleverapps.CODE_SUCCEED) {
                        f();
                    } else {
                        callback(false);
                    }
                }, { signInWindow: "viral" });
            },

            (f) => {
                if (connector.platform.isExitFullscreenAvailable()) {
                    connector.platform.exitFullscreen(f);
                } else {
                    f();
                }
            },

            () => connector.platform.shareCallback(shareData, callback)
        ]).play();
    },

    // the connector picks the invite channel; the player signs in through the viral window where the channel needs it
    inviteFriends: function (shareId, callback, payload) {
        const shareData = cleverapps.SocialManager.getShareData(shareId);
        if (payload) {
            shareData.payload = payload;
        }

        connector.platform.inviteFriends(shareData, callback, {
            login: (done) => cleverapps.SocialManager.enforceLogin((code) => {
                done(code === cleverapps.CODE_SUCCEED ? connector.CODE_SUCCEED : connector.CODE_FAILED);
            }, { signInWindow: "viral" })
        });
    },

    getShareData: function (id) {
        const data = cc.loader.getRes(bundles.main.jsons.vk_json);
        const vkPictures = data[id] || data.default;

        let path = `${id}_${cleverapps.settings.language}`;
        if (!bundles.shares.urls[`${path}_1`]) {
            path = `${id}_en`;
        }
        if (!bundles.shares.urls[`${path}_1`]) {
            path = "default_en";
        }

        const pictures = [];
        for (let i = 1; i < 15; i++) {
            const picture = bundles.shares.urls[`${path}_${i}`];

            if (!picture) {
                break;
            }

            pictures.push(picture.getUrl());
        }

        const shareData = {
            title: Messages.get(`Share.${id}.Name`),
            text: Messages.get(`Share.${id}.Description`),
            image: PseudoRandom.GET().mathChoose(pictures)
        };

        if (connector.platform.oneOf(connector.VK)) {
            shareData.image = PseudoRandom.GET().mathChoose(vkPictures);
        }

        if (connector.platform.oneOf(connector.PLINGA)) {
            shareData.linktext = Messages.get("PlayNow");
        }

        if (connector.platform.oneOf(connector.DRAUGIEM)) {
            shareData.subTitle = Messages.get("PlayNow");
        }

        return shareData;
    }
};
